module.exports = __webpack_public_path__ + "img/kelebihan-3.95fd4d69.jpg";